import React, { useRef } from "react";

import { P_Props } from "./UploadBtn.type";
import clsx from "clsx";
import { useClickOutside } from "../../../hooks";
import { UploadIcon } from "../../../app/icons";

const UploadBtnPresenter: React.FC<P_Props> = (props) => {

  const primaryBtnRef: any = useRef(null);
  useClickOutside(primaryBtnRef, () => {
    props.onBlurPrimary && props.onBlurPrimary();
  });

  const classes = clsx({ "upload-button": true, [props.className || ""]: Boolean(props.className) });
  return (
    <div className={classes}>
      <div ref={primaryBtnRef} onClick={props.onClickPrimary} className="upload-button__item">
        <div className="upload-button__item__circle primary">
          <UploadIcon size={[25, 26]} color="#fff" />
        </div>
        <div className="upload-button__item__text hide">Primary</div>
      </div>
    </div>
  );
};

export default UploadBtnPresenter;
